import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import { TABS_TYPE } from '../../ProfileSettings';

import './Settings.styles.scss';

export class Settings extends React.Component {
  get actions() {
    const { tabs = [], mode } = this.props;

    return [
      {
        id: 'radio-mode-saved',
        type: TABS_TYPE.lastSession,
        label: I18n.t('Open tabs from last session')
      },
      {
        id: 'radio-mode-default',
        type: TABS_TYPE.custom,
        label: I18n.t('Open the following tabs:'),
        content: (
          <div className={cx('Settings__tabs', { 'Settings__tabs-disabled': mode != TABS_TYPE.custom })}>
            {tabs.map((tab) => (
              <label key={tab.label} className="Settings__tabs__item">
                <input
                  id={`cbx-${tab.fieldName}`}
                  type="checkbox"
                  data-tab-id={tab.fieldName}
                  name={`Profile-settings-${tab.label}`} 
                  checked={tab.value}
                  onChange={this.handleTabsChange}
                />
                {tab.label}
              </label>
            ))}
          </div>
        )
      },
    ];
  }

  handleTabModeChange = (e) => {
    e.persist();

    const { dataset } = e.currentTarget;

    this.props.onTabModeChange(dataset.type);
  }

  handleTabsChange = (e) => {
    e.persist();

    const { dataset, checked } = e.currentTarget;

    this.props.onTabsChange(dataset.tabId, checked);
  }

  render() {
    const actionName = 'Profile-settings-action';
    const { mode } = this.props;

    return (
      <div className="Settings">
        <h4 className="Settings__heading">{I18n.t('Upon Login')}</h4>

        <div className="Settings__actions">
          {this.actions.map((action) => (
            <div className="Settings__actions__item" key={action.type}>
              <label className="Settings__actions__item__label" id={action.id}>
                <input
                  checked={mode == action.type}
                  name={actionName}
                  data-type={action.type} 
                  type="radio" 
                  onChange={this.handleTabModeChange}
                />
                {I18n.t(action.label)}
              </label>

              {action.content}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
